export type Contact = {
  publicId: string;
  name?: string | null;
  email?: string | null;
  isPrimary?: boolean | null;
};

export const sortContacts = <T extends Contact>(contacts: readonly T[]): T[] =>
  [...contacts].sort((a, b) => {
    if (a.isPrimary && !b.isPrimary) return -1;
    if (!a.isPrimary && b.isPrimary) return 1;
    return (a.name ?? '').localeCompare(b.name ?? '');
  });

/**
 * Maps an entity's stored customerContact into a pinned recipient: once sent,
 * the recipient reflects who actually received it, even if the contact has
 * since been edited or removed from the Customer.
 */
export const buildPinnedRecipient = (
  customerContact:
    | { publicId: string; name?: string | null; email?: string | null }
    | null
    | undefined
): Contact | null => {
  if (!customerContact) return null;
  return {
    publicId: customerContact.publicId,
    name: customerContact.name ?? null,
    email: customerContact.email ?? null,
    isPrimary: false,
  };
};

export const resolveRecipient = <T extends Contact>(
  contacts: T[],
  override: T | null
): T | null => {
  const defaultRecipient =
    contacts.find((c) => c.isPrimary) ?? contacts[0] ?? null;
  return (
    (override && contacts.find((c) => c.publicId === override.publicId)) ||
    defaultRecipient
  );
};
